import { createStore } from 'vuex'
import { defineStore } from 'pinia'
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})

